import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-in-progress',
  template: `
    @if (loading) {
      <div class="app-loader-wrapper">
        <div class="portal-logo" [ngClass]="{ 'small': small }">
          <div class="loader"></div>
        </div>
      </div>
    }`,
  standalone: false
})
export class InProgressComponent {
  @Input() loading = false;
  @Input() small = false;
}
